import posthog from 'posthog-js';

// Flag to track if PostHog has been initialized by our code
let isInitialized = false;

/**
 * Initialize PostHog if it hasn't been initialized already
 * This prevents duplicate initialization issues when used in multiple places
 */
export function initPostHog() {
  // Skip initialization in SSR context
  if (typeof window === 'undefined') {
    return posthog;
  }

  // Check if already initialized by us
  if (isInitialized) {
    return posthog;
  }

  // Check if already initialized elsewhere (by inspecting the object)
  try {
    // PostHog sets __loaded when it's initialized
    if ((posthog as any).__loaded || (posthog as any)._loaded) {
      console.debug('PostHog was already initialized elsewhere');
      isInitialized = true;
      return posthog;
    }

    // Check if the instance has properties that indicate it's initialized
    if (posthog.persistence && posthog.sessionManager) {
      console.debug('PostHog appears to be already initialized');
      isInitialized = true;
      return posthog;
    }

    // Initialize PostHog
    console.debug('Initializing PostHog');
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || '/ingest',
      defaults: '2025-05-24',
      // ui_host: 'https://us.posthog.com',
      // person_profiles: 'identified_only',
      // capture_pageview: 'history_change', // Recommended for Next.js SPAs
      // capture_pageleave: true,
      // persistence: 'localStorage+cookie',
      // autocapture: true,
      // disable_session_recording: false,
      // rageclick: true,
      // mask_all_text: false,
      // mask_all_element_attributes: false,
      loaded: (posthog) => {
        if (process.env.NODE_ENV === 'development') {
          posthog.opt_out_capturing(); // Disable in development
          console.debug('PostHog loaded - capturing disabled in development');
        } else {
          console.log('PostHog loaded and ready');
        }
      },
    });

    isInitialized = true;
    console.debug('PostHog initialized successfully');
  } catch (error) {
    console.error('Error initializing PostHog:', error);
  }

  return posthog;
}

// Export the singleton instance that will be used throughout the app
export default posthog;
